exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".direction-input[data-v-6892ec1f]{direction:ltr}.direction-label[data-v-6892ec1f]{text-align:left}.fontStyle[data-v-6892ec1f]{font-size:12px}.errorStyle[data-v-6892ec1f]{color:red}.errorStyle[data-v-6892ec1f],.fontWeight[data-v-6892ec1f]{font-weight:bolder}", ""]);

// exports
